import { RPDF } from '../common/react-pdf';
import React from 'react';
import { ColorCircle } from '../svg/ColorCircle';
import { ChartInfo } from '../common/types';
import { useTranslation } from 'react-i18next';

interface Props {
  data: ChartInfo[];
}

export const VisitTypesList: React.FC<Props> = (props) => {
  const i18next = useTranslation();

  return (
    <RPDF.View style={RPDF.chartStyles.listContainer}>
      {props.data.map((item) => {
        return (
          <RPDF.View style={RPDF.chartStyles.listRow} key={item.visitType.name}>
            <ColorCircle color={item.visitType.color} />
            <RPDF.Text style={RPDF.chartStyles.listTypeText}>
              {i18next.t(item.visitType.name as any)}:
            </RPDF.Text>
            <RPDF.Text style={RPDF.chartStyles.listCountText}>
              {item.count}
            </RPDF.Text>
          </RPDF.View>
        );
      })}
    </RPDF.View>
  );
};
